import { Component } from '@angular/core';

import { pedidoStatusOutro } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-outro',
    templateUrl: './pedido-status-badge-outro.component.html',
    styleUrls: ['./pedido-status-badge-outro.component.less']
})
export class PedidoStatusBadgeOutroComponent {
    status = pedidoStatusOutro;
}
